export default "__VITE_ASSET__CWKxt8LC__"